import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export function getCacheStats() {
  return request(`${ROOT_SERVER_URL}/api/cache/stats`);
}

export function clearAllCache() {
  return request(`${ROOT_SERVER_URL}/api/cache/flush`, {
    method: 'POST',
  });
}
